import type { SiteShowSummaryRes } from '@on3/api';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { On3Avatar } from 'components/Image/On3Avatar';

import styles from './ShowsItem.module.scss';

interface IShowsItemProps {
  item: SiteShowSummaryRes;
}

export const CollegeShowsItem = ({ item }: IShowsItemProps) => {
  const slug = slugify(item?.featuredShow?.name);
  const teamUrl = (item?.site?.url || '/').replace(/\/$/, '');
  const key = item?.featuredShow?.key;
  const siteName = item?.site?.name;
  const link =
    item?.showCount === 1
      ? `${teamUrl}/shows/${slug}-${key}`
      : `${teamUrl}/shows/`;

  return (
    <li className={styles.block}>
      <a className={styles.inner} href={link}>
        <div className={styles.avatar}>
          <On3Avatar
            className={styles.logo}
            domain={item?.organization?.defaultAsset?.domain}
            height={30}
            source={item?.organization?.defaultAsset?.source}
            teamAvatar
            width={30}
          />
          <span>{item?.organization?.name}</span>
        </div>
        <div className={styles.meta}>
          <h3>
            <span className={styles.name}>{item?.organization?.fullName}</span>
            <span className={styles.subText}>{item?.organization?.mascot}</span>
          </h3>
          <span className={styles.subText}>{`Hosted By ${siteName}`}</span>
        </div>
      </a>
    </li>
  );
};
